import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { faqs } from './landingConstants';
import './LandingFaqSection.css';

const LandingFaqSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section
      id="faq"
      className="landing-faq landing-section-equal py-8 sm:py-10 lg:py-14 bg-slate-950 border-b border-white/5"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-10 sm:mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium bg-indigo-500/15 text-indigo-200 border border-indigo-400/20 mb-3 sm:mb-4">
            FAQ
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-100 mb-4">
            Common questions
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-slate-300">
            Answers to help your team evaluate fit, setup, and rollout.
          </p>
        </motion.div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const isOpen = index === openIndex;
            return (
              <div key={item.question} className="landing-faq__item">
                <button
                  type="button"
                  className="w-full px-4 sm:px-5 py-4 text-left flex items-start justify-between gap-4"
                  onClick={() => setOpenIndex((current) => (current === index ? null : index))}
                >
                  <span className="text-sm sm:text-base font-medium text-slate-100">
                    {item.question}
                  </span>
                  <ChevronDownIcon
                    className={`h-5 w-5 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.2 }}
                      className="overflow-hidden"
                    >
                      <p className="px-4 sm:px-5 pb-4 text-sm sm:text-base text-slate-300">
                        {item.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
        <div className="mt-6 text-center">
          <a href="#" className="landing-back-to-top">
            Back to top
            <span aria-hidden="true">↑</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default LandingFaqSection;
